import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/2fa-backup")({
	component: RouteComponent,
});

function RouteComponent() {
	return <div>Hello "/auth/2fa-backup"!</div>;
}
